'use client';

import { UiProvider as Provider } from '@jouzen/ecom-components';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import type { PropsWithChildren } from 'react';

import useCurrency from '../hooks/useCurrency';

interface UiProviderProps extends PropsWithChildren {
  readonly locale: string;
}

function UiProvider({ children, locale }: UiProviderProps) {
  const { countryData, currencyCode } = useCurrency();
  const t = useTranslations();
  return (
    <Provider
      // @ts-expect-error --Fix type error
      ImageComponent={Image}
      LinkComponent={Link}
      currencyProps={{
        country: countryData?.countryCode ?? 'US',
        fallbackCurrencyCode: currencyCode,
        fallbackLocale: locale,
        freeMessage: t('cart_free'),
        locale,
      }}
      intlProps={{ locale }}
    >
      {children}
    </Provider>
  );
}

export default UiProvider;
